export default __webpack_public_path__ + "static/media/Indiecita.8ca33517.png";